import React, { Fragment, useEffect, useState } from 'react'; 
import HeroSection from '../../Components/Main/Common/HeroSection';
import ContactContent from '../../Components/Main/Contact/ContactContent';
import '../../CSS/contact.scss';
import getUrl from '../../Utility/GetUrl';
import { fetchData } from '../../Utility/GlobalService';
import {Dots} from 'react-preloaders2';

const Contact = ()=> { 
  const [contactSectionData,setContactSectionData] = useState();
  const [loading,setLoading] = useState(true);
  useEffect(()=>{
    getContactSectionData();
    setLoading(false);
  },[]);
  const getContactSectionData = async()=>{
    const response = await fetchData(`${getUrl()}/contact`);
    setContactSectionData(response);
    // console.log(response);
  }
  const heroSectionContent = {
    title: "CONNECTING WITH PEOPLE IS IMPORTANT",
    content: `LET’S GET CONNECTED`
  };

  const contactData = [
    {
      phone: [{number: '+8801869701485'},{number: '+8801768745043'}],
      email: [{address: 'chiran.tonmoy.swe@gmail.com'},{address: 'tonmoychiran449@gmail.com'}],
      location: [{address: 'ka-22/2/A,Kalachandpur, School Road, Baridhara, Gulshan , Dhaka - 1212'}]
    }
  ];
  return (
    <Fragment>
      <Dots background="#000" color="#00FFA5" customLoading={loading}/>
      <div className="contact-page">
          <div className="hero-section-container">
            {contactSectionData && <HeroSection data={contactSectionData}/>}
          </div>
          <div className="contact-details">
              <ContactContent data={contactData}/>
          </div>
      </div>
    </Fragment>
  );
}

export default Contact; 